<template>
<div class="chapter">
<div class="inner_page">
<p class="alsoby"><a id="pageii"></a><a href="#/OEBPS/toc.htm#also">Also by Val McDermid</a></p>
<p class="center"><em>A Place of Execution</em></p>
<p class="center"><em>Killing the Shadows</em></p>
<p class="center"><em>The Grave Tattoo</em></p>
<p class="center"><em>A Darker Domain</em></p>
<p class="center"><em>Trick of the Dark</em></p>
<p class="center"><em>The Vanishing Point</em></p>
<p class="center"><em>Northanger Abbey</em></p>
<p class="series">TONY HILL/CAROL JORDAN NOVELS</p>
<p class="center"><em>The Mermaids Singing</em></p>
<p class="center"><em>The Wire in the Blood</em></p>
<p class="center"><em>The Last Temptation</em></p>
<p class="center"><em>The Torment of Others</em></p>
<p class="center"><em>Beneath the Bleeding</em></p>
<p class="center"><em>Fever of the Bone</em></p>
<p class="center"><em>The Retribution</em></p>
<p class="center"><em>Cross and Burn</em></p>
<p class="center"><em>Insidious Intent</em></p>
<p class="series">KAREN PIRIE NOVELS</p>
<p class="center"><em>The Distant Echo</em></p>
<p class="center"><em>A Darker Domain</em></p>
<p class="center"><em>The Skeleton Road</em></p>
<p class="center"><em>Out of Bounds</em></p>
<p class="series">KATE BRANNIGAN NOVELS</p>
<p class="center"><em>Dead Beat</em></p>
<p class="center"><em>Kick Back</em></p>
<p class="center"><em>Crack Down</em></p>
<p class="center"><em>Clean Break</em></p>
<p class="center"><em>Blue Genes</em></p>
<p class="center"><em>Star Struck</em></p>
<p class="series">LINDSAY GORDON NOVELS</p>
<p class="center"><em>Report for Murder</em></p>
<p class="center"><em>Common Murder</em></p>
<p class="center"><em>Booked for Murder</em></p>
<p class="center"><em>Hostage to Murder</em></p>
<p class="series">SHORT STORY COLLECTIONS</p>
<p class="center"><em>The Writing on the Wall and Other Stories Stranded</em></p>
<p class="center"><em>Christmas is Murder</em> (ebook only)</p>
<p class="center"><em>Gunpowder Plots</em> (ebook only)</p>
<p class="series">NON FICTION</p>
<p class="center"><em>A Suitable Job for a Woman Forensics</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// also.vue?35fbd715